import React from "react";
import AdminReviews from "../components/AdminReviews/AdminReviews";

const AdminReviewPage = () => {
  return <AdminReviews />;
};

export default AdminReviewPage;
